module.exports = __webpack_public_path__ + "img/lc_pjyl.e22c0fdd.svg";